import {sanityFetch} from 'utils/sanity.fetch';

import type {OrderFormSchema} from 'components/content-blocks/order-form/schema';

import type {FormPricesQueryResult} from './query';
import {FORM_PRICES_QUERY} from './query';
import {OrderFormRender} from './render';

type Props = {
	section: OrderFormSchema;
};

export const OrderFormServer = async ({section}: Props) => {
	const formPrices = await sanityFetch<FormPricesQueryResult>({query: FORM_PRICES_QUERY});

	if (!formPrices) {
		return <div>Kunne ikke laste priser!</div>;
	}

	return <OrderFormRender section={section} formPrices={formPrices} />;
};
